exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GwdAJ {\n  position: absolute;\n  top: 2px;\n  right: 60px;\n  padding: 10px 15px;\n  color: #A89A72;\n  cursor: pointer;\n}\n._2D5sq {\n  position: absolute;\n  top: 2px;\n  right: 0;\n  padding: 10px 15px;\n  color: #A89A72;\n  cursor: pointer;\n}\n._2tCol {\n  margin-top: 5px;\n  padding-top: 10px;\n  height: calc(100% - 220px);\n  overflow: auto;\n}\n._2tCol ul {\n  margin: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"btnUpdate": "GwdAJ",
	"btnReset": "_2D5sq",
	"list": "_2tCol"
};